import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import translate from '../TranslateHOC';
import * as c from '../../constants'
import { show } from 'redux-modal'
import { bindActionCreators } from 'redux'
import { signOutUser } from '../../actions'

class MyS4CAuthNav extends Component {

    constructor () {
        super();
        this.handleOpen = this.handleOpen.bind(this);
        this.signOut = this.signOut.bind(this);
    }

    handleOpen = name => () => {
        const trans = this.props.strings;
        this.props.show(c.CONFIRM_DIALOG, {
            message: trans.confirmSignOut,
            confirmLbl: trans.signOut,
            cancelLbl: trans.cancel,
            handleSubmit: this.signOut
        });
    };

    signOut() {
        this.props.signOutUser();
    }

    render() {
        const trans = this.props.strings;
        const active = this.props.active;

        return (
	        <div className="sub-header">
	            <div className="my-s4c-header">
	                <nav className="my-s4c-header__nav my-s4c-header__nav--auth">
	                    <ul className="my-s4c-header__list">
		                    <li className="my-s4c-header__item">
	                            <Link className={ "my-s4c-header__link" + (active === c.PATH_WATCHING ? " my-s4c-header__link--active": "") }  to={c.PATH_WATCHING}>
	                                {trans.watching}
	                            </Link>
	                        </li>
	                        <li className="my-s4c-header__item">
	                            <Link className={ "my-s4c-header__link" + (active === c.PATH_MY_LIST ? " my-s4c-header__link--active": "") } to={c.PATH_MY_LIST}>
	                                {trans.myList}
	                            </Link>
	                        </li>
	                        <li className="my-s4c-header__item">
	                            <Link className={ "my-s4c-header__link" + (active === c.PATH_PROFILES || active.includes(c.PATH_PROFILE_EDIT) ? " my-s4c-header__link--active": "") }  to={c.PATH_PROFILES}>
	                                {trans.profiles}
	                            </Link>
	                        </li>
	                        <li className="my-s4c-header__item">
	                            <Link className={ "my-s4c-header__link" + (active === c.PATH_PARENT ? " my-s4c-header__link--active": "") } to={c.PATH_PARENT}>
	                                {trans.parentalControl}
	                            </Link>
	                        </li>
	                    </ul>
	                </nav>
	                <nav className="my-s4c-header__nav my-s4c-header__nav--auth my-s4c-header__nav--right">
	                    <ul className="my-s4c-header__list">
	                        <li className="my-s4c-header__item">
	                            <Link className={ "my-s4c-header__link" + (active.lastIndexOf(c.PATH_ACCOUNT,0) ===0 ? " my-s4c-header__link--active": "") }  to={c.PATH_EDIT}>
	                                {trans.accountSettings}
	                            </Link>
	                        </li>
	                        <li className="my-s4c-header__item">
	                            <button className="my-s4c-header__link"
	                               onClick={this.handleOpen(c.CONFIRM_SIGN_OUT_DIALOG)}>
	                                {trans.signOut}
	                            </button>
	                        </li>
	                    </ul>
	                </nav>
	            </div>
            	</div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signOutUser: () => dispatch(signOutUser()),
        show: bindActionCreators(show, dispatch),
    };
};

export default translate((connect (null, mapDispatchToProps ))(MyS4CAuthNav));
